/**
 * exatrek REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: v3
 * Contact: dev@exatrek.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MachineIdDto } from './machineIdDto';

export interface ISOTaskDataV2Dto {
  created?: string;
  filename?: string;
  id?: number;
  machine?: MachineIdDto;
  name?: string;
  processed?: string;
  state?: string;
}
